import { useEffect } from "react";

export function useIframeResize() {
  useEffect(() => {
    const root = document.getElementById("root");
    if (!root) return;

    const sendHeight = () => {
      window.parent.postMessage(
        {
          type: "campnerd.resize",
          height: root.getBoundingClientRect().height,
        },
        "*",
      );
    };

    sendHeight();

    const observer = new ResizeObserver(sendHeight);
    observer.observe(root);

    return () => {
      observer.disconnect();
    };
  }, []);
}
